export const AUTH_UNAUTHENTICATED_EVENT = 'auth-authenticated'
